import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, useStyleConfig} from '@chakra-ui/react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import TypeOneInside from './variants/type-one-inside'
import TypeOneOutside from './variants/type-one-outside'
import TypeTwoInside from './variants/type-two-inside'
import TypeTwoOutside from './variants/type-two-outside'

const VARIANTS = {
    uniform: {inside: TypeOneInside, outside: TypeOneOutside},
    featured: {inside: TypeTwoInside, outside: TypeTwoOutside},
}

export const Bentobox = ({
    sectionTitle,
    sectionSubtitle,
    cards = [],
    layoutVariant,
    flag,
    imagesTypeOne,
    imageTwo,
    imageTextPosition,
}) => {
    const featured = layoutVariant === '3-Card Featured Asymmetric Grid' || layoutVariant === '2'
    const variant = featured ? 'featured' : 'uniform'
    const outside = flag ?? (imageTextPosition === 'Below image' || imageTextPosition === 'Outside')
    const textMode = outside ? 'outside' : 'inside'
    const Variant = VARIANTS[variant][textMode]
    const styles = useStyleConfig('Bentobox', {variant})
    const {locale} = useMultiSite()
    const categoriesData = useGetCategoriesData()
    const localeId = locale?.alias || locale?.id?.toLowerCase()
    const repeatedCards = imagesTypeOne?.images_1 ?? cards
    const featuredCard = imageTwo && {
        ...imageTwo,
        image: {
            desktop: imageTwo.desktop,
            tablet_1024: imageTwo.tablet_1024,
            tablet_768: imageTwo.tablet_768,
            mobile: imageTwo.mobile,
        },
    }
    const visibleCards = featured
        ? featuredCard
            ? [featuredCard, ...repeatedCards.slice(0, 2)]
            : repeatedCards.slice(0, 3)
        : repeatedCards

    if (!visibleCards.length) return null

    return (
        <Box
            {...styles?.container}
            data-testid="bentobox-container"
            data-layout-variant={variant}
            data-bentobox-version={`${featured ? '2' : '1'}-${textMode}`}
        >
            {(sectionTitle || sectionSubtitle) && (
                <Flex {...styles?.header}>
                    {sectionTitle && (
                        <Text as="h2" {...styles?.title}>
                            {sectionTitle}
                        </Text>
                    )}
                    {sectionSubtitle && <Text {...styles?.subtitle}>{sectionSubtitle}</Text>}
                </Flex>
            )}
            <Variant
                cards={visibleCards}
                styles={styles}
                flag={flag}
                imageTextPosition={imageTextPosition}
                localeId={localeId}
                categoriesData={categoriesData}
            />
        </Box>
    )
}

Bentobox.propTypes = {
    sectionTitle: PropTypes.string,
    sectionSubtitle: PropTypes.string,
    layoutVariant: PropTypes.string,
    flag: PropTypes.bool,
    imageTextPosition: PropTypes.string,
    imagesTypeOne: PropTypes.shape({images_1: PropTypes.array}),
    imageTwo: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        icon: PropTypes.shape({url: PropTypes.string}),
        desktop: PropTypes.object,
        tablet_1024: PropTypes.object,
        tablet_768: PropTypes.object,
        mobile: PropTypes.object,
    }),
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            _metadata: PropTypes.shape({uid: PropTypes.string}),
            title: PropTypes.string,
            subtitle: PropTypes.string,
            body_copy: PropTypes.string,
            image: PropTypes.object,
            icon: PropTypes.shape({url: PropTypes.string}),
            text_position: PropTypes.string,
            flag: PropTypes.bool,
            blur_overlay: PropTypes.bool,
            url: PropTypes.string,
            link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            button: PropTypes.object,
        }),
    ),
}

export default Bentobox
